import { useTranslation } from 'react-i18next';
import React, { useCallback, useState } from 'react';

import style from './index.module.scss';
import { Button, Input } from '@/components';
import { useGroupProposalCreate } from '@/views/GroupProposal/hooks/create';
type ModalProps = {
  hide(): void;
  groupId: number;
};

export const RenameGroupModal = ({ hide, groupId }: ModalProps) => {
  const { t } = useTranslation();

  const [name, setName] = useState<string>();

  const { mutateAsync, isLoading } = useGroupProposalCreate(groupId);

  const onConfirm = useCallback(() => {
    mutateAsync({
      type: 'rename',
      data: {
        name,
      },
    }).then(res => {
      if (res.proposal) {
        hide();
      }
    });
  }, [hide, mutateAsync, name]);

  return (
    <div className={style.leaveGroupModal}>
      <div className={style.header}>{t('GroupModalManager_RenameGroupModal.1hundz3')}</div>
      <Input
        placeholder={t('GroupModalManager_RenameGroupModal.placeholder')}
        value={name}
        className={style.input}
        onChange={setName}
        maxLength={30}
      />
      <div className={style.subDesc}>{t('GroupModalManager_RenameGroupModal.1j7362z')}</div>
      <div className={style.buttons}>
        <Button
          type="primary"
          className={style.button}
          onClick={onConfirm}
          disabled={!name}
          loading={isLoading}>
          {t('GroupModalManager_RenameGroupModal.mf1qqm')}
        </Button>
      </div>
    </div>
  );
};
